import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {BlockBaseComponent} from "../block-base/block-base.component";
import {TranslocoService} from "@ngneat/transloco";
import {ContainerService, LocalStoreService, StoreSelectorsService} from "../../../../services";
import {IButtonBar} from "../../../../components/add-remove-bar/button-bar.component";
import {ITableListColumn, ITableListEvent} from "../../../../components/table-list-input/table-list-input.component";
import {actionSceneItemPlaylist, actionSceneJumpLinked} from "../../../../store/actions/user.actions";
import {DialogGetAssetComponent, IDialogGetAsset} from "../../../../components/dialog-get-asset/dialog-get-asset.component";
import {SceneMimeTypes} from "../mime-constants";
import {IPage} from "../../../../interfaces";
import {getTotalLengthPlaylist, isNullOrUndef, MAX_PLAYLIST_TIME} from "../../../../common";
import {ToastrService} from 'ngx-toastr';
import {filter, map, take} from 'rxjs/operators';
import {combineLatest} from 'rxjs';
import {Lib} from "../../../../../libs/Lib";
import {Router} from '@angular/router';
import * as _ from "lodash";

@Component({
    selector: 'app-block-collection',
    templateUrl: './block-collection.component.html',
    styleUrls: ['./block-collection.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlockCollectionComponent extends BlockBaseComponent {

    buttons: IButtonBar[] = [];
    tableColumns: Array<ITableListColumn> = [];
    transitionsEnabled = '0';

    constructor(private translocoService: TranslocoService,
                public override storeSelector: StoreSelectorsService,
                private toastr: ToastrService,
                public override dialog: MatDialog,
                private containerService: ContainerService,
                public cd: ChangeDetectorRef,
                private router: Router,
                protected override localStoreService: LocalStoreService
    ) {
        super(storeSelector, dialog);
        this.transitionsEnabled = this.localStoreService.getStorageValConfig('transitionsEnabled');
        this.tableColumns = [{
            inputType: 'edit',
            name: 'page',
            maxStringSize: '16'
        }, {
            inputType: 'fixed',
            name: 'type',
            maxStringSize: '16'
        }];
        this.buttons = [
            // {
            //     callBack: v => (v),
            //     icon: 'commit',
            //     name: 'list',
            //     disableByList: false,
            //     disabled: false,
            //     tooltip: this.translocoService.translate('general.playlistTimeline', {}, this.translocoService.getActiveLang())
            // },
            {
                callBack: v => (v),
                icon: 'add',
                name: 'add',
                disableByList: false,
                disabled: false,
                tooltip: this.translocoService.translate('general.add', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'remove',
                name: 'remove',
                disableByList: true,
                confirmRemove: this.translocoService.translate('toast.deleteConfirm', {}, this.translocoService.getActiveLang()),
                disabled: false,
                tooltip: this.translocoService.translate('general.remove', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'arrow_left',
                name: 'previous',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.next', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'arrow_right',
                name: 'next',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.previous', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'link',
                name: 'link',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.jumpToItem', {}, this.translocoService.getActiveLang()),
            },
        ];
    }

    onCollectionTimeline() {
        this.containerService.updateEditorMode('collectionMode');
    }

    override componentInit() {
        super.componentInit();
        const playlistIndexes$ = this.storeSelector.listenSelectedScenePlaylist();
        const sceneUpdate$ = this.storeSelector.listenPlayersOfScene(this.sceneId);
        this.toggleDuration();
        this.cod(
            combineLatest([playlistIndexes$, this.containerService.editorMode, sceneUpdate$]).pipe(
                map(([indexes, containerServiceMode, sceneUpdate]) => {
                    if (containerServiceMode === 'collectionMode') return indexes;
                    return null;
                }),
                filter((v) => v !== null)
            ).subscribe((indexes) => {
                super.initApplyStoreToDynamic(true);
                this.tableListSelection('Page', indexes);
                this.cd.detectChanges();
            })
        );
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
        this.toggleDuration();
        this.cd.markForCheck();
        // super.initApplyStoreToDynamic(true);
    }

    toggleDuration() {
        switch (this.sceneItem.Data[0].Collection[0].$.mode) {
            case 'kiosk': {
                this.setUiConfigHide('duration', true);
                break;
            }
            case 'slideshow': {
                this.setUiConfigHide('duration', false);
                break;
            }
        }
        this.cd.markForCheck();
    }

    updateTransition() {

    }

    private onTableListChangeCallBack(e: ITableListEvent) {
        if (e.currentAction === 'selected') {
            this.storeSelector.dispatch(actionSceneItemPlaylist({indexes: e.selectedIndexes}));

        } else if (e.currentAction === 'previous' || e.currentAction === 'next') {
            // this.storeSelector.dispatch(actionSceneItemPlaylist({indexes: e.selectedIndexes}));

        } else if (e.currentAction === 'link') {
            this.jumpToPlayer(e.selected[0]);
            this.dialog.closeAll();

        } else if (e.currentAction === 'rename') {
            const oldPages = this.sceneItem.Data[0].Collection[0].Page;
            const pages = e.values;
            if (pages && _.isArray(pages)) {
                const len = getTotalLengthPlaylist(pages);
                if (len > MAX_PLAYLIST_TIME) {
                    this.showToastOverLength();
                    // this.storeSelector.dispatch({type: 'UNDO'});
                    this.dispatchSceneItemChanges({
                        sceneId: this.sceneId,
                        sceneItemId: this.sceneItem.$.id,
                        values: [{
                            key: 'Page',
                            value: oldPages,
                            storePath: 'Data[0].Collection[0]'
                        }]
                    });
                    super.initApplyStoreToDynamic(true);
                } else {
                    this.dispatchSceneItemChanges({
                        sceneId: this.sceneId,
                        sceneItemId: this.sceneItem.$.id,
                        values: [{
                            key: 'Page',
                            value: e.values,
                            storePath: 'Data[0].Collection[0]'
                        }]
                    });
                }
            }
        } else if (e.currentAction === 'drop' || e.currentAction === 'removed') {
            this.dispatchSceneItemChanges({
                sceneId: this.sceneId,
                sceneItemId: this.sceneItem.$.id,
                values: [{
                    key: 'Page',
                    value: e.values,
                    storePath: 'Data[0].Collection[0]'
                }]
            });
        } else if (e.currentAction === 'list') {
            this.onCollectionTimeline();
        } else if (e.currentAction === 'added') {
            this.openAssociateDialog(true, 'Page');
            this.storeSelector.dispatch(actionSceneItemPlaylist({indexes: []}));
        }
    }

    override submit(formValues) {
        super.submit(formValues);
        // if (this.onFormSubmitAction(formValues)) {
        //     super.submit(formValues);
        // }
    }

    jumpToPlayer(item) {
        const itemType = item?.$?.type;
        if (!item || !itemType) return;

        if (itemType === 'scene') {
            const src = item?.Player[0]?.$?.src;
            if (!src) return;

            this.storeSelector.dispatch(actionSceneJumpLinked({previousLinkedSceneId: this.sceneId}));
            this.containerService.updateEditorMode(null);
            this.router.navigateByUrl(`/editor/scene/${src}`);
        } else {
            this.router.navigateByUrl(`/resources/list?filter=${item.$.page}`);
        }
    }

    /** Unused function: this is deprecated by tableaction: disableSubmit */
    private onFormSubmitAction(e): boolean {
        let returnVal = null;
        Object.entries(e).map((items: Array<any>) => {
            const tableName = items[0];
            items.forEach((val: ITableListEvent) => {
                if (isNullOrUndef(val?.currentAction)) return returnVal = true;
                Lib.DevShow(`>>> onFormSubmitAction ${tableName} | ${val.currentAction}| selected ${val.selected.length} | values ${val.values.length}`);
                switch (val.currentAction) {
                    case 'selected':
                    case 'externallySelected': {
                        return returnVal = false;
                    }
                    case 'list': {
                        this.onCollectionTimeline();
                        return returnVal = false;
                    }
                    case 'added': {
                        this.openAssociateDialog(true, tableName);
                        this.storeSelector.dispatch(actionSceneItemPlaylist({indexes: []}));
                        return returnVal = true;
                    }
                    case 'removed':
                    case 'rename': {
                        return returnVal = true;
                    }
                    default: {
                        return returnVal = true;
                    }
                }
            });
        });
        return returnVal;
    }

    openAssociateDialog(addingNew, tableName: 'pageGps' | 'Page') {
        const data: IDialogGetAsset = {mode: "SCENE_RESOURCE:PLAYER", mimeType: SceneMimeTypes.Player, multiSelect: true};
        const dialogRefVal = this.dialog.open(DialogGetAssetComponent, {
            width: '70%',
            panelClass: 'custom-dlg-container',
            data
        });
        this.cod(
            dialogRefVal.afterClosed()
                .pipe(take(1))
                .subscribe((dialogGetAssets: IDialogGetAsset[]) => {
                    if (!dialogGetAssets || !Array.isArray(dialogGetAssets)) return;
                    this.addTableItem(dialogGetAssets);
                })
        );
    }

    addTableItem(dialogGetAssets: IDialogGetAsset[]) {
        let pager: IPage;
        const pages = this.sceneItem.Data[0].Collection[0].Page && _.isArray(this.sceneItem.Data[0].Collection[0].Page) ? _.cloneDeep(this.sceneItem.Data[0].Collection[0].Page) : [];

        for (const dialogGetAsset of dialogGetAssets) {
            switch (dialogGetAsset.selectedType) {
                case "RESOURCE_SELECTED": {
                    const resource_type = dialogGetAsset.sourceData.resource_type;
                    const playerId = (["mp4", "mov", "m4v", "3gp"].indexOf(resource_type) > -1) ? "3100" : "3130";

                    pager = {
                        $: {
                            page: `${dialogGetAsset.sourceData.resource_name}`,
                            type: "resource",
                            duration: "5"
                        },
                        Player: [
                            {
                                "$": {
                                    player: playerId,
                                    id: _.uniqueId('__')
                                },
                                Data: [
                                    {
                                        Resource: [
                                            {
                                                $: {
                                                    resource: dialogGetAsset.selected
                                                }
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    };
                    break;
                }
                case "SCENE_SELECTED": {
                    pager = {
                        $: {
                            page: dialogGetAsset.sourceData.Player.$.label,
                            type: "scene",
                            duration: "5"
                        },
                        Player: [
                            {
                                $: {
                                    src: dialogGetAsset.selected
                                }
                            }
                        ]
                    };
                    break;
                }
            }
            pages.push(pager);
        }

        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: 'Page',
                value: pages,
                storePath: 'Data[0].Collection[0]'
            }]
        });
        super.initApplyStoreToDynamic(true);
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.collectionName', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "label",
                storePath: '$.label'
            },
            // {
            //     type: "input",
            //     label: this.translocoService.translate('general.mode', {}, this.translocoService.getActiveLang()),
            //     name: "mode",
            //     value: "mode",
            //     ignoreMissingValue: true,
            //     storePath: 'Data[0].Collection[0].$.mode',
            //     disabled: true
            // },
            // {
            //     type: "input",
            //     value: '',
            //     min: '1',
            //     max: '999',
            //     label: this.translocoService.translate('general.duration', {}, this.translocoService.getActiveLang()),
            //     inputType: "number",
            //     name: "duration",
            //     storePath: 'Data[0].Collection[0].$.duration'
            // },

            {
                type: "input",
                label: '',
                inputType: 'tablelist',
                tableColumns: this.tableColumns,
                ignoreMissingValue: true,
                cloneVals: true,
                multiSelect: false,
                rememberSelection: false,
                allowFilter: true,
                buttonBarClassName: 'playlistButtonBar',
                buttons: this.buttons,
                inputEditFormat: {page: 'text'},
                inputEditRenamePath: [{path: '$.page', key: 'page'}, {path: '$.type', key: 'type'}],
                name: "Page",
                storePath: 'Data[0].Collection[0].Page',
                disableSubmit: true,
                expandableEditor: true,
                allowTableOnDialog: true,
                callBackEvent: (v) => this.onTableListChangeCallBack(v)
                // callBackFaIcon: (v) => BlockPlaylistComponent.onCallBackFaIcon(v),
            }
        ];
        if (this.transitionsEnabled === '1') {
            this.uiConfigInit.splice(1, 0, {
                type: "select",
                label: this.translocoService.translate('general.transitionPool', {}, this.translocoService.getActiveLang()),
                name: "handle",
                value: "",
                options: [],
                observable: this.storeSelector.getTransitionPools(),
                optionValue: "id",
                optionLabel: "transition_pool_name",
                defaultOption: {value: '', label: 'None'},
                storePath: 'Data[0].TransitionPool[0].$.handle'
            });
        }
    }

    private showToastOverLength() {
        this.toastr.error(this.translocoService.translate('general.tooLong24', {}, this.translocoService.getActiveLang()));
    }

}
